<template>
  <div class="modal fade show usr_info">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close_user"><img src="../assets/image/icon-close.png" alt="" /></div>
        <div class="title"><img src="../assets/image/submit.png" alt="" /></div>
        <div class="resc"><img src="../assets/image/reg_success.png" alt="" /></div>
        <div class="content">
          <p>tài khoản: {{ info.username }}</p>
          <p>mật khẩu: {{ info.password }}</p>
        </div>
        <div class="submit_btn" @click="toLogin">
          <img src="../assets/image/login_btn.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  props: ["info"],
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    toLogin() {
      this.$emit("toLogin");
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  background: rgba(0, 22, 53, 0.6);
  &.show {
    display: block;
    animation: fadeIn 0.15s linear;
  }
}
.usr_info {
  .title {
    text-align: center;
    img {
      width: 50px;
    }
  }
  .resc {
    text-align: center;
    margin: 20px 0;
    img {
      width: 60%;
    }
  }
  .content {
    color: #fff;
    p {
      margin-bottom: 12px;
      font-size: 20px;
    }
  }
  .close_user {
    position: absolute;
    right: 0;
    top: -10px;
  }
  .submit_btn {
    position: absolute;
    bottom: -40px;
    left: 0;
    width: 100%;
    text-align: center;
    img {
      width: 80%;
    }
  }
}
</style>
